import { PageRequest } from "@shared/dtos/requests/pageRequest.dto"
import { CreatePracticeRequest } from "@shared/dtos/requests/practiceRequests.dto"
import { PracticePageResponse } from "@shared/dtos/responses/practiceResponses.dto"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

/**
 * Find all practices (that are not soft-deleted)
 */
export const findAll = async (query?: PageRequest): Promise<PracticePageResponse> => {
  const resp = await axiosAuth({
    url: "/admin/practices",
    method: "get",
    params: query,
  })
  return resp.data
}

/**
 * Creates practice
 */
export const create = async (req: CreatePracticeRequest): Promise<void> => {
  await axiosAuth({
    url: "/admin/practices",
    method: "post",
    data: req,
  })
  return undefined
}

/**
 * Removes practice
 */
export const remove = async (id: string): Promise<void> => {
  await axiosAuth({
    url: `/admin/practices/${id}`,
    method: "delete",
  })
}
